import { render } from "./cta.vue?vue&type=template&id=02901d30&scoped=true"
import script from "./cta.vue?vue&type=script&lang=js"
export * from "./cta.vue?vue&type=script&lang=js"

import "./cta.vue?vue&type=style&index=0&id=02901d30&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-02901d30"

export default script